import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('color') 
export class skechersColorEntity {
    @PrimaryGeneratedColumn('increment', {
        name: 'color_id',
    })
    colorId: number

    @Column('varchar',{
        name:'item_no',
        nullable:false,
       
    })
    itemNo: string

    @Column('varchar',{
        name:'po_color_name',
        nullable:false,
       
    })
    poColorName: string

    @Column('varchar',{
        name:'crm_color_name',
        nullable:false,
    })
    crmColorName: string


    @Column({
        nullable: false,
        name: "is_active",
        default:1
    })
    isActive: boolean;

    @Column('varchar', {
        nullable: true,
        length: 20,
        name: 'created_user'
    })
    createdUser: string | null;

    @Column('varchar', {
        nullable: true,
        length: 20,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: string;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: string;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    
}